import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from './reducers/types';
import type { AppDispatch } from './index';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <T>(selector: (state: RootState) => T): T =>
  useSelector<RootState, T>(selector);
